import {Constants} from "../config/constants";
import Cookies from 'js-cookie';

let accessToken;
let refreshToken;
let userInfo;
let academicInfo;

const init = () => {
    accessToken = JSON.parse(Cookies.get(Constants.STORAGE_ACCESS_TOKEN));
    refreshToken = JSON.parse(Cookies.get(Constants.STORAGE_REFRESH_TOKEN));
    userInfo = JSON.parse(Cookies.get(Constants.STORAGE_USER_INFO));
    academicInfo = JSON.parse(Cookies.get(Constants.STORAGE_ACADEMIC_INFO));
};

export class Auth {
    // static setCookies = (key, data, callback) => callback(Cookies.set(key, JSON.stringify(data)));
    // static removeCookies = (key, callback) => callback(Cookies.remove(key));

    // Change this line in your Auth class:
    static setCookies = (key, data, callback) => {
        // Setting 'expires: 7' makes the cookie last for 7 days
        // This ensures the user stays logged in even if the app is closed.
        return callback(Cookies.set(key, JSON.stringify(data), { expires: 7, path: '/' }));
    };

    // 2. Add path here to ensure it matches the setCookies path
    static removeCookies = (key, callback) => {
        Cookies.remove(key, { path: '/' });
        return callback();
    };

    static getAccessToken = () => {
        init();
        return accessToken.token;
    };

    static getRefreshToken = () => {
        init();
        return refreshToken.token;
    };

    static getUserInfo = () => {
        init();
        return userInfo;
    };
    static getAcademicInfo = () => {
        init();
        return academicInfo;
    };

    static clearLocalStorage = () => {
        init();
        setTimeout(() => window.location.href = window.location.origin + '/login', 1500);
        localStorage.clear();
    };

    static userLocked = () => {
        init();
        setTimeout(() => window.location.href = window.location.origin + '/locked', 1500);
    };

    static renewTokens = (data) => {
        // Alert.error({title: 'Please try again', status: 'Token Renewed!'});
        Auth.setCookies(Constants.STORAGE_ACCESS_TOKEN, data.access, (cb) => {
            Auth.setCookies(Constants.STORAGE_REFRESH_TOKEN, data.refresh, (cb) => {
                return true;
            })
        })
    }


}
